import styled from 'styled-components';
import PencilIcon from 'js/components/core/Icons/PencilIcon';

export default styled(PencilIcon)`
  height: 1rem;
  width: 1rem;
  margin: 0 1rem;
`;
